import { render } from "./Snapshot.vue?vue&type=template&id=65967758&ts=true"
import script from "./Snapshot.vue?vue&type=script&lang=ts"
export * from "./Snapshot.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Build\\vsts-agent-win-x64-3.218.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__